export default "__VITE_ASSET__V$aj$eUE__"